import { render, staticRenderFns } from "./AwayTeamTable.vue?vue&type=template&id=6d113db6&scoped=true&"
import script from "./AwayTeamTable.vue?vue&type=script&lang=js&"
export * from "./AwayTeamTable.vue?vue&type=script&lang=js&"
import style0 from "./AwayTeamTable.vue?vue&type=style&index=0&id=6d113db6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d113db6",
  null
  
)

export default component.exports